export default () => ({
    syncSteps: {
        width: '100%',
        maxWidth: 400,
    },
});
